import React from 'react';
import { oneOfType, string, number } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Content } from './Content';

export const ContentContainer = ({ pipTimeout, ...props }) => {

  return (
    <QueryProvider
      cacheKey="content-page"
      defaultVariables={{ name: '' }}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Content {...props} />
    </QueryProvider>
  );
};

ContentContainer.propTypes = {
  pipTimeout: oneOfType([string, number])
};

ContentContainer.defaultProps = {
  pipTimeout: '3000'
};